import { Type } from "@sinclair/typebox";
const text = Type.String();
const id = Type.String({ minLength: 1, maxLength: 512, pattern: "^[^\\r\\n\\u0000]+$" });
const status = Type.Optional(Type.Union([Type.Literal("in_progress"), Type.Literal("completed"), Type.Literal("incomplete")]));
const inputText = Type.Object({ type: Type.Literal("input_text"), text }, { additionalProperties: false });
const outputText = Type.Object({ type: Type.Literal("output_text"), text }, { additionalProperties: false });
/** 只登记自包含的文本及原生推理历史；执行项和 provider 资源引用均不在合同内。 */
export const ModelHistoryItemSchema = Type.Union([
    Type.Object({
        type: Type.Optional(Type.Literal("message")),
        id: Type.Optional(id),
        role: Type.Union([Type.Literal("user"), Type.Literal("developer"), Type.Literal("system")]),
        content: Type.Union([text, Type.Array(inputText, { minItems: 1 })]),
        status,
    }, { additionalProperties: false }),
    Type.Object({
        type: Type.Optional(Type.Literal("message")),
        id: Type.Optional(id),
        role: Type.Literal("assistant"),
        content: Type.Union([text, Type.Array(Type.Union([inputText, outputText]), { minItems: 1 })]),
        phase: Type.Optional(Type.Union([Type.Literal("commentary"), Type.Literal("final_answer"), Type.Null()])),
        status,
    }, { additionalProperties: false }),
    Type.Object({
        type: Type.Literal("reasoning"),
        id: Type.Optional(Type.Union([id, Type.Null()])),
        summary: Type.Array(Type.Object({ type: Type.Literal("summary_text"), text }, { additionalProperties: false }), {}),
        content: Type.Optional(Type.Union([
            Type.Null(),
            Type.Array(Type.Object({ type: Type.Literal("reasoning_text"), text }, { additionalProperties: false }), {}),
        ])),
        encrypted_content: Type.Optional(Type.Union([text, Type.Null()])),
        status,
    }, { additionalProperties: false }),
    Type.Object({
        type: Type.Literal("compaction"),
        id: Type.Optional(Type.Union([id, Type.Null()])),
        encrypted_content: Type.String({ minLength: 1 }),
    }, { additionalProperties: false }),
]);
export const ModelProxyInputSchema = Type.Union([
    text,
    Type.Array(ModelHistoryItemSchema, { minItems: 1 }),
]);
//# sourceMappingURL=model-history.js.map